<script lang="ts">
	import { getTranslate } from "@utils/getTranslate.js";
	import shield from "@core/assets/icons/shield.svg?raw";
	import { Currency } from "@core/schema/Currency.js";
	import { membershipPricePerCurrencyMap } from "@core/schema/utils/membershipPricePerCurrencyMap.js";
	import { formatPrice } from "@core/utils/formatPrice.js";
	import { Cart } from "../cart/Cart.svelte.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import translations from "./FathersChoiceCancellable.translations.json" with { type: "json" };
	import Formatted from "./common/Formatted.svelte";
	import Icon from "./common/Icon.svelte";

	const translate = getTranslate(translations);
	const { tenant } = getGlobalTemplateProps();

	const membershipPrice = $derived.by(() => {
		const currency = Cart.currency ?? Currency.CZK;
		return formatPrice(membershipPricePerCurrencyMap[currency], currency, tenant.locale, false);
	});
</script>

<div class="flex px-3.5 gap-3.5 py-3 rounded-xl bg-fcrbeige shrink-0">
	<Icon icon={shield} aria-hidden="true" class="size-4 text-fcrbrown" />
	<div class="text-xs/normal">
		<Formatted text={translate("label", { membershipPrice })} />
	</div>
</div>
